<template>
  <b-container
    v-if="this.$route.params.type == 'professionista'"
    fluid
    class="col-12 border-secondary bg-secondary text-white font-weight-bold mx-auto border__div px-0 pt-0 mb-4 note"
  >
    <h5 class="font-weight-bold pt-1">I tuoi appunti</h5>
    <h6 class="font-weight-bold py-0">Questa sezione è visibile solamente a te</h6>
    <div class="d-flex flex-column py-2 px-2">
      <div class="note__div pl-2">
        <p
          class="m-auto text-left text-capitalize"
          v-for="(nota, ind) in note"
          :key="ind"
        >. {{ nota }}</p>
        <br />
      </div>
      <b-form-input
        class="m-auto"
        v-model="nota"
        placeholder="Aggiungi appunto..."
        v-on:keydown="addNota"
      ></b-form-input>
    </div>
  </b-container>
</template>
<script>
export default {
  name: "note-professionista",
  props: ["appunti"],
  data() {
    return {
      note: [],
      nota: null,
      hash: null,
      test: null
    };
  },
  methods: {
    addNota(e) {
      // console.log("keydown", e);
      if (e.keyCode == 13) {
        this.note.push(this.nota);
        this.nota = null;
        this.updateNote();
      }
    },
    getNote() {
      var url = process.env.VUE_APP_VERSION + "note/" + this.appunti.hashid;

      this.$axios
        .get(url)
        .then(res => {
          console.log(res.data.data);
          this.hash = res.data.data.hashid;
          // this.note.push(res.data.data.appunti);
        })
        .catch(err => {
          // console.log(err);
          if (err.response.status === 401) {
            this.$router.go();
          }
        });
    },
    updateNote() {
      var url = process.env.VUE_APP_VERSION + "note/" + this.hash;
      var data = { appunti: this.note.join("\n") };

      this.$axios
        .put(url, data)
        .then(res => {
          console.log(res.data.data);
          this.test = res.data.data;
        })
        .catch(err => {
          // console.log(err);
          if (err.response.status === 401) {
            this.$router.go();
          }
        });
    }
  },
  created() {
    // console.log(this.appunti);
    // if (this.appunti) {
    //   console.log(this.appunti);
    //   this.hash = this.appunti.hashid;
    // }
    // this.getNote();
  },
  mounted() {
    this.hash = this.appunti.hashid;
  }
};
</script>
<style scoped>
.note {
  min-height: 50vh;
}
.note__div {
  min-height: 30vh;
}
</style>
